<template>
  <div class="language-control">
    <div
      class="language-control__current"
      :class="{ active: showList }"
      @click="showList = !showList"
    >
      <div class="language-control__current-title">
        {{ selectedLocale.title }}
      </div>
      <div class="language-control__caret" :class="{ active: showList }">
        <svg
          width="8"
          height="5"
          viewBox="0 0 8 5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.31216 4.86424L7.8722 1.07685C7.9546 0.989247 8 0.872312 8 0.747627C8 0.622941 7.9546 0.506006 7.8722 0.418408L7.61008 0.139492C7.43929 -0.0419999 7.1617 -0.0419999 6.99116 0.139492L4.00166 3.31986L1.00884 0.135964C0.926432 0.0483657 0.816579 0 0.699441 0C0.582174 0 0.472322 0.0483657 0.389851 0.135964L0.127804 0.414879C0.0453982 0.502546 4.76837e-07 0.619413 4.76837e-07 0.744098C4.76837e-07 0.868783 0.0453982 0.985719 0.127804 1.07332L3.69109 4.86424C3.77376 4.95205 3.88413 5.00028 4.00146 5C4.11925 5.00028 4.22956 4.95205 4.31216 4.86424Z"
            fill="#2C2C30"
          />
        </svg>
      </div>
    </div>
    <div class="language-control__list" v-if="showList">
      <div
        class="language-control__item"
        v-for="locale in localesList"
        :key="`locale-${locale.key}`"
        @click="changeLocale(locale.key)"
      >
        {{ locale.title }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SET_LOCALE } from "@/store/action-types";

export default {
  name: "LanguageControl",
  data() {
    return {
      availableLocales: [
        // {
        //   key: "ru",
        //   title: "Рус",
        // },
        {
          key: "uk",
          title: "Укр",
        },
        {
          key: "en",
          title: "Eng",
        }
      ],
      showList: false,
    };
  },
  created() {},
  computed: {
    ...mapState(["app"]),
    selectedLocale: function () {
      return this.availableLocales.find(
        (al) => al.key === this.app.currentLocale
      );
    },
    localesList() {
      return this.availableLocales.filter(
        (al) => al.key !== this.selectedLocale.key
      );
    },
  },
  methods: {
    changeLocale(locale) {
      this.showList = false;
      this.$store.dispatch(SET_LOCALE, locale);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.language-control {
  position: relative;

  &__current {
    position: relative;
    display: flex;
    align-items: center;
    padding: 13px 16px;
    z-index: 1;
    cursor: pointer;
    font-size: pxToRem(12);
    line-height: pxToRem(15);
    font-weight: 600;
    color: $black;
    transition: opacity 0.2s linear, color 0.2s linear;

    &:hover {
      opacity: 0.8;
    }

    &.active {
      color: $action;
    }
  }

  &__caret {
    margin-left: 6px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.active {
      transform: rotate(-180deg);
      svg {
        path {
          fill: $action;
        }
      }
    }
  }

  &__list {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 43px 16px 13px;
    background: #ffffff;
    box-shadow: 0 10px 20px rgba(183, 180, 214, 0.2);
    border-radius: 16px;
  }

  &__item {
    font-size: pxToRem(12);
    line-height: pxToRem(15);
    font-weight: 600;
    color: $black;
    cursor: pointer;
    transition: opacity 0.2s linear, color 0.2s linear;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
